import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center mb-5" }

import FormAgregatorComponents from "@/components/formAggregator/formAgregatorComponents.vue";
import CompanyDetailsComponent from "./companyDetails/companyDetailsComponent.vue";
import AccountDetailsComponent from "./accountDetails/accountDetailsComponent.vue";
import LocationDataComponent from "./locationData/locationDataComponent.vue";
import BankDetailComponent from "./bankDetails/bankDetailsComponent.vue";
import DeliveryComponent from "./delivery/deliveryComponent.vue";
import { IStore } from "@/store/types/StoreType";
import { computed, onBeforeMount, ref, watch } from "vue";
import { useStore } from "vuex";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";
import { PersonalDataComponent } from "@/store/modules/accountDetails/type";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailsView',
  setup(__props) {

const store = useStore<IStore>();
const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));


watch(
  () => uiLang.value,
  () => {
    store.commit("updateAllPhone");
  }
);

onBeforeMount(() => {
  const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
  const initialValues = ref<PersonalDataComponent>(
    store.getters?.getPersonalDataComponenValuesAccountDetails
  );

  switch (uiLang.value.toUpperCase()) {
    case "SWEDISH":
      SeoTitle("Tyre point: Företag - " + initialValues.value.firm_name);
      SeoDescription(
        "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
      );
      break;
    case "FINLAND":
      SeoTitle("Tyre point: Yhtiö - " + initialValues.value.firm_name);
      SeoDescription(
        "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
      );
      break;
    default:
      SeoTitle("Tyre point: Company - " + initialValues.value.firm_name);
      SeoDescription(
        "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
      );
      break;
  }
});

watch(
  () => uiLang.value,
  () => {
    const initialValues = ref<PersonalDataComponent>(
      store.getters?.getPersonalDataComponenValuesAccountDetails
    );

    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoTitle("Tyre point: Företag - " + initialValues.value.firm_name);
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoTitle("Tyre point: Yhtiö - " + initialValues.value.firm_name);
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoTitle("Tyre point: Company - " + initialValues.value.firm_name);
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc("account_details")), 1),
    _createVNode(FormAgregatorComponents, null, {
      default: _withCtx(() => [
        _createVNode(CompanyDetailsComponent),
        _createVNode(BankDetailComponent),
        _createVNode(LocationDataComponent),
        _createVNode(DeliveryComponent),
        _createVNode(AccountDetailsComponent)
      ]),
      _: 1
    })
  ], 64))
}
}

})